import { documentReady } from "@sazka/utils/document-ready";
import {
    quickBetCardSelectors,
    initQuickBetCardHeaders,
    initQuickBetCardLists,
} from "@sazka/design-system/src/quick-bet-card/ds-quick-bet-card";

const initQuikcBetCards = () => {
    const wrappers: HTMLElement[] = [...document.querySelectorAll(quickBetCardSelectors.wrapper)] as HTMLElement[];
    const cards: HTMLElement[] = [...document.querySelectorAll(quickBetCardSelectors.card)] as HTMLElement[];

    wrappers.forEach(initQuickBetCardHeaders);
    cards.forEach(initQuickBetCardLists);
};

documentReady(initQuikcBetCards);
